/* eslint react-hooks/immutability: ["warn"] */
import { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { TaskCard } from "./TaskCard";
import styles from "./swipeable-task-card.module.css";
import { MoreButton } from "./MoreButton";
import { PickupTaskButton } from "./PickupTaskButton";
import { CompleteButtons } from "./CompleteButtons";
import { TaskType } from "../../enums/taskTypes";
import useFixaLocation from "@coworker/apprestructured/src/shared/wrappers/FixaLocation/useFixaLocation";
import { Item } from "../../../shared/types/item";
import { FullTask } from "../../../TasksOverview/types/FullTask";

interface SwipeableTaskCardProps {
  task: FullTask;
  item: Item;
  multiSelect: boolean;
  isMyTasks: boolean;
  type: string;
  disableSwipe?: boolean;
  disablePickup?: boolean;
  onShowTaskDetails: (taskId: string, taskType: TaskType) => void;
}

export const SwipeableTaskCard = ({
  task,
  item,
  multiSelect,
  isMyTasks = false,
  type,
  disableSwipe = false,
  disablePickup = false,
  onShowTaskDetails,
}: SwipeableTaskCardProps) => {
  const [swipeDirection, setSwipeDirection] = useState<"left" | "right" | "">(
    ""
  );
  const [isSwiping, setIsSwiping] = useState(false);
  const location = useFixaLocation();
  const isAddonTask = task.task_type === TaskType.ADDON;
  const isRelatedTasks = location.pathname.includes("related");

  let swipeTimeout: NodeJS.Timeout;

  const handlers = useSwipeable({
    onSwiped: () => {
      if (!multiSelect && !isRelatedTasks) {
        setIsSwiping(true);
        clearTimeout(swipeTimeout);
        swipeTimeout = setTimeout(() => {
          setIsSwiping(false);
        }, 100);
      }
    },
    onSwipedLeft: () => {
      if (!multiSelect && !isRelatedTasks) {
        setSwipeDirection(swipeDirection === "right" ? "" : "left");
      }
    },
    onSwipedRight: () => {
      if (!multiSelect && !isRelatedTasks) {
        if (swipeDirection === "left") {
          setSwipeDirection("");
        } else if (!disablePickup) {
          setSwipeDirection("right");
        }
      }
    },
    trackMouse: true,
  });

  if (disableSwipe) {
    return (
      <TaskCard
        task={task}
        item={item}
        multiSelect={multiSelect}
        isSwiping={isSwiping}
        type={type}
        onShowTaskDetails={onShowTaskDetails}
      />
    );
  }

  return (
    <div className={styles["swipeable-task-card"]} {...handlers}>
      <div
        className={
          swipeDirection === "left"
            ? styles["swipe-left"]
            : swipeDirection === "right"
              ? isMyTasks && isAddonTask
                ? styles["swipe-big-right"]
                : styles["swipe-right"]
              : styles["swipe-none"]
        }
      >
        <TaskCard
          task={task}
          item={item}
          multiSelect={multiSelect}
          isSwiping={isSwiping}
          type={type}
          onShowTaskDetails={onShowTaskDetails}
        />
      </div>
      <MoreButton
        swipeDirection={swipeDirection}
        setSwipeDirection={setSwipeDirection}
        task={task}
      />
      {isMyTasks && (
        <CompleteButtons
          swipeDirection={swipeDirection}
          setSwipeDirection={setSwipeDirection}
          isAddonTask={isAddonTask}
          task={task}
        />
      )}
      {!disablePickup && !isMyTasks && (
        <PickupTaskButton
          swipeDirection={swipeDirection}
          setSwipeDirection={setSwipeDirection}
          task={task}
        />
      )}
    </div>
  );
};
